export enum StorageKeys {
  ACCESS_TOKEN = 'token',
  SELF_DETAILS = 'selfDetails',
  PREFERENCES = 'preferences',
  USER_EMAIL = 'userEmail',
}
